const $ = require('jquery');
import LookupTable from "../../components/lookupTable/index";
import run from '../../utilities/run';
import {isPresent, getESTDate, shallAllowClick} from "../../utilities/general";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT,SUCCESS_MODAL_TIMEOUT} from "../../constants";
import render from "../../utilities/render";
import {buildExport,statusPillRender,prepareDataToSendController,isEdit,readSpecificObjectFromCurrentData,doAjax,readSpecificKeyFromSearchCriteria,alterSearchCriteriForController,pushFilterSessionCacheState,retriveCriteriaObjectByOperation,isNew,isDeleteView,isOnlyLookupDataUpdate} from "../../utilities/filtersutil";
import {orderLookupFieldDropdown} from "./filter/orderLookupFieldDropdown.js";
import {actionOptions} from "./filter/actionOptions.js";
const _ = require("underscore");
import {keyDefaultFalseOption} from '../../utilities/general';
let actionList = actionOptions;
const targetSelector = "#order-lookup";
import {handleCustomDropdownEvents} from "../../utilities/customBootstrapDropdowns";

let actionCellDropdownTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionCellDropdown.html');
let actionCellDropdownItemTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionCellDropdownItem.html');
let actionHeaderDropdownTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionHeaderDropdown.html');
let statusPillRenderTemplate = require("../../utilities/filtersutil/html/statusPillsTemplate.html");
const detailLinkHTML = require('../../utilities/filtersutil/html/detailLinkHTML.html');
const editErrorOrderModal = require("./html/editErrorOrderModal.html");
const editBackOrderedOrderModal = require("./html/editBackOrderedOrderModal.html");
const editHeldOrderModal = require("./html/editHeldOrderModal.html");
const editCustomHeldOrderModal = require("./html/editCustomHeldOrderModal.html");
const editChannelHeldOrderModal = require("./html/editChannelHeldOrderModal.html");
const editPortalHeldOrderModal = require("./html/editPortalHeldOrderModal.html");
const modalHtml = require("../../sharedHtml/modal.html");
import { pillStatusClasses } from "../../utilities/filtersutil";
const statusPillBodyHtml = require('./html/statusPill.html');
const datTimeFormat = "MM/DD/YYYY hh:mm A";

run(targetSelector, ()=>{
	const dataTableComponentData =  $(targetSelector).data("order-lookup-data");
    const viewOrderDetailURL =  $(targetSelector).data("order-detail-url");
    const portletNamespace =  $(targetSelector).data("portlet-namespace");
    const filterOrderUrl =  $(targetSelector).data("order-filter-url");
    const orderFilterData =  $(targetSelector).data("table-filter-data");
    const cancelOrderUrl =  $(targetSelector).data("cancel-url");
    const releaseOrderUrl =  $(targetSelector).data("release-url");
    const getCancelReasonUrl  =  $(targetSelector).data("cancel-reasons-list-url");
    const generateExportUrl  =  $(targetSelector).data("export-url");
    const shouldCheckCache  =  $(targetSelector).data("should-check-cache");
    const bulkCancelOrderUrl  =  $(targetSelector).data("bulk-cancel-url");
    const bulkReleaseOrderUrl  =  $(targetSelector).data("bulk-release-url");
    const savedViews  =  $(targetSelector).data("saved-views");
    const saveViewURL  =  $(targetSelector).data("save-view-url");
    const deleteViewURL  =  $(targetSelector).data("delete-view-url");
    var disableCancel = dataTableComponentData.disableCancel;
    const disableEdit = $(targetSelector).data("order-lookup-disable-edit");
    const editOrderUrl = $(targetSelector).data("edit-order-url");
		const filterFlag = $(targetSelector).data("filter-flag");
		const facId = $(targetSelector).data("fac-id");

    let exportModal = new buildExport();
    var submitModalFlow = new SubmitModalFlow();
    submitModalFlow.init();
    const extraDetailForCacheFromServer  =  $(targetSelector).data("extra-detail-for-cache-from-server");
    const criteriaObjectFromServer  =  $(targetSelector).data("filter-criteria-from-server");
    let targetObject = "";
    const orderPortletEditPerm = $(targetSelector).data("order-portlet-edit-perm");
    let selectedRows = "";

    if(shouldCheckCache)
    {
		targetObject = retriveCriteriaObjectByOperation(criteriaObjectFromServer,"like");
	}

	function renderPill(data, type, row) {
    	return data;
  	}

   function createDetailLink(data, type, row) {
		let detailPageHTML = render(
			detailLinkHTML, {
			  renderURL :  viewOrderDetailURL,
			  portletNamespace :  portletNamespace,
			  id :   row.ordOrderId,
			  idName : "orderId",
			  displayVal:row.ordOrderId
			}
		);
		return detailPageHTML;
    }

  	function createOrderTypeText(data, type, row) {
  		if(isPresent(data)){
	  		if(data == "B2C") {
	  			return "B2C-Business to customer";
	  		}else if(data == "B2B") {
	  			return "B2B-Business to business";
	  		}else if(data == "TRF"){
	    	  return "TRF-Transfer Order" ;
        }else if(row.ordOrtName != ""){
	    	  return data + "-" + row.ordOrtName;
	      }
  		}
    	return "";
  	}

	function formateDate(createdDate, type, data){
		if(createdDate != null && createdDate != ""){
		  var date = new Date(createdDate); //createdDate is long time format
		  var month = date.getMonth() + 1;
		  var today = new Date();
		  var oneDay = 24*60*60*1000;
		  today.setHours(0,0,0,0);
		  date.setHours(0,0,0,0);
		  var diffDays = Math.floor(Math.abs((today.getTime() - date.getTime())/(oneDay)));
		  var friendlyText = "";
		  var datePillHTML  = ""
		  if(diffDays < 100){
		  	friendlyText = diffDays.toString() + ' Days Ago';
		  	datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>"+  friendlyText +"</span>"
		  }
		  if(diffDays == 0){
		    friendlyText = 'Today';
		  }else if(diffDays== 1){
		    friendlyText ='Yesterday'
		  }
		  return (month.toString().length > 1 ? month : "0" + month) + "/" + date.getDate() + "/" + date.getFullYear() + datePillHTML;
		}else{
		  return "";
		}
	}

    var orderLookup = new LookupTable({
	    // REQUIRED - Set a target element
	    target: $("#lookup-order-wrapper"),
	    // Set a target class for min width, needs to be a "til-x" class so it doesn't interfere with mobile widths
	    minWidthClass: "q-min-width-sm-til-md",
	    // REQUIRED - Set which data should be visible for mobile
	    mobileColumns: [
	        {
	          data: "ordOrderId",
	          title: "FedEx Order ID",
	          render: createDetailLink
	        },
	        {
	          data: "ordShipToName",
	          title: "Customer Name",
	          orderable:false,
	        },
	        {
	          data: "ordChannelType",
	          title: "Channel"
	        },
	        {
	          data: "ordParOrderNumber",
	          title: "Channel Order ID"
	        },
	        {
	          data: "ordStatus",
	          title: "Status",
	          render: statusPillRender
	        },
	        {
	          data: "ordShipmentTrkStatus",
	          title: "Shipping Status",
	          render: statusPillRender
	        }
	    ],
	   // tableFilters: {
	   //    data: orderFilterData,
	   //  },

	    // REQUIRED: search input info
	    tableSearchInput: {
	      // Not required
	      // placeholder: 'Custom Search Text'
	      value: (targetObject != "" ? targetObject.value[0] : "")

	    },
	    // REQUIRED - THIS IS TEMPORARY, WILL BE DEPRECATED WHEN WE ENABLE SEARCH INPUT ONLY
	    tableSearchDropdown: {
		  selected: (targetObject == "" ? "" : targetObject.key),
	      columns:orderLookupFieldDropdown
	    },
	    // OPTIONAL: Set Saved View Array
   		savedViews: savedViews,
   		bulkSelect: true,
	    // REQUIRED - Data Table specific settings
	    dataTable: {
	      // use same settings you would if you were just calling a dataTable normally
	    data: dataTableComponentData.content,
	      // Not required, just to show you can
	    columnDefs: [
	        { className: "custom-class", targets: [ 1 ] }
	    ],
	      // Not required, just to show you can
	    order: [
	        [7, 'asc'],
	    ],
	    columns: [
	        {
	          data: "ordStatus",
	          render : renderActionWrap,
	          orderable:false,
	          class: 'dtc-action-column'
            },
	        {
	          data: "ordOrderId",
	          title: "FedEx Order ID",
	          render: createDetailLink,
	          class: 'dtc-min-width-md'
	        },
	        {
	          data: "ordShipToName",
	          title: "Customer Name",
   			  	class: 'dtc-min-width-sm'
	        },
	        {
	          data: "ordChannelType",
	          title: "Channel",
	          class: 'dtc-min-width-sm'
	        },
	        {
	          data: "ordOrderType",
	          title: "Order Type",
	          render: createOrderTypeText,
	          class: 'dtc-min-width-sm'
	        },
	        {
	          data: "ordParOrderNumber",
	          title: "Channel Order ID",
	          class: 'dtc-min-width-sm'
	        },
	        {
	          data: "ordStatus",
	          title: "Status",
	          render: statusPillRender,
	          class: 'dtc-min-width-sm'
	        },
	        {
	          data: "ordCreatedDate",
	          title: "Date Received",
	          render: formateDate,
	          class: 'dtc-min-width-md'
	        },
	        {
	          data: "ordShipToEmail",
	          title: "Customer Email",
	          class: 'dtc-min-width-sm'
	        },
	        {
	          data: "ordShipToPhone",
	          title: "Customer Phone",
	          class: 'dtc-min-width-sm'
	        },
	        {
	          data: "ordShipToAddress1",
	          title: "Address1",
	          class: 'dtc-min-width-md'
	        },
	        {
	          data: "ordShipToAddress2",
	          title: "Address2",
	          class: 'dtc-min-width-sm'
	        },
	        {
	          data: "ordShipToCity",
	          title: "City",
	          class: 'dtc-min-width-sm'
	        },
	        {
	          data: "ordShipToState",
	          title: "State/Province/Region",
	          class: 'dtc-min-width-sm'
	        },
	        {
	          data: "ordShipToZip",
	          title: "Postal Code",
	          class: 'dtc-min-width-sm'
	        },
	        {
	          data: "ordShippingType",
	          title: "Shipping Type",
	          render: getShippingType,
	          class: 'dtc-min-width-sm'
	        },
	        {
	          data: "orsShipDate",
	          title: "Date Shipped",
	          class: 'dtc-min-width-md'
			},
			{
				data: "ordShippingMethod",
				title: "Shipping Method",
				class: 'dtc-min-width-sm'
			},
	        {
	          data: "ordShipmentTrkStatus",	
	          title: "Shipping Status",
	          render: statusPillRender,
	          class: 'dtc-min-width-sm'
	        }
	      ]
	    },
	   //  tableColumnModal: {
      	//	data: orderLookupColumnsPopup
    	//},
	    paginationData:dataTableComponentData.page,
	    filterModal: {
	      // REQUIRED: Sets title of modal
	      title: "Filter Orders",
	      // REQUIRED: Sets unique part of subtitle string.
	      tableType: "orders"
	    },
	 	onBulkSelectChange: function() {
		    selectedRows = orderLookup.getBulkSelectedData();
    	    $("th.dtc-action-column").html(renderActionHeaderWrap());
		    if (selectedRows.length >= 2) {
				$(".action-header-btn .base-btn").removeClass('disabled');
			}else{
			    $(".action-header-btn .base-btn").addClass('disabled');
			};
		},
	    onFetch: function() {
				let currentData = orderLookup.generateData();
	      orderLookup.showLoadingOverlay();
	      //Withing lookup screen onFetch fun. can be called for different level of actions - like New view , Edit view, Delete view and Search, remove pills
       if(isOnlyLookupDataUpdate(currentData)){
       	  	setTimeout(() => {
				doAjax({url: filterOrderUrl, success: filterSuccessFun, error: errorFun,data:prepareDataToSendController(currentData)});
	      	},SUCCESS_MODAL_TIMEOUT);
		   }else if(isNew(currentData)){
       	  	 setTimeout(() => {
	    		doAjax({url: saveViewURL, success: savedViewSuccess, error: errorFun, data:prepareDataToSendController(currentData)});
	      	 },SUCCESS_MODAL_TIMEOUT);
       	   }else if(isEdit(currentData)){
       	  	 setTimeout(() => {
	    		doAjax({url: saveViewURL, success: savedEditViewSuccess, error: errorFun, data:prepareDataToSendController(currentData)});
	      	 },SUCCESS_MODAL_TIMEOUT);
       	   }else if(isDeleteView(currentData)){
       	  	 setTimeout(() => {
	    		doAjax({url: deleteViewURL, success: delteViewScussFun, error: errorFun, data:prepareDataToSendController(currentData)});
	      	 },SUCCESS_MODAL_TIMEOUT);
       	   }
		}
    });

	function filterSuccessFun(data){
		let orders = data.content;
		let page = data.page;
		orderLookup.setNewData(orders);
		orderLookup.setPaginationData(page)
		pushFilterSessionCacheState();
		orderLookup.hideLoadingOverlay();
		setExportData(orderLookup.generateData());
	}

	function savedViewSuccess(data){
	    let orders = data.lookupOrderJSON.content;
	    let page = data.lookupOrderJSON.page;
	    orderLookup.setNewData(orders);
	    orderLookup.setPaginationData(page);
	    orderLookup.setNewSavedViewData(data.savedView, "newSavedView");
	  	pushFilterSessionCacheState();
	    orderLookup.hideLoadingOverlay();
	    setExportData(orderLookup.generateData());
	}

	function getShippingType(data){
		if(data==="PCL"){
			return "Case";
		}else if(data==="LTL"){
			return "Freight";
		}else{
			return "-";
		}
	}


	function savedEditViewSuccess(data){
	    let orders = data.lookupOrderJSON.content;
	    let page = data.lookupOrderJSON.page;
	    orderLookup.setNewData(orders);
	    orderLookup.setPaginationData(page);
	    orderLookup.setNewSavedViewData(data.savedView, data.savedView.target);
	  	pushFilterSessionCacheState();
	    orderLookup.hideLoadingOverlay();
	    setExportData(orderLookup.generateData());
	}


	function delteViewScussFun(data){
		let orders = data.lookupOrderJSON.content;
	    let page = data.lookupOrderJSON.page;
		orderLookup.removeSavedView(data.target);
		orderLookup.setNewData(orders);
	    orderLookup.setPaginationData(page);
		orderLookup.hideLoadingOverlay();
	    setExportData(orderLookup.generateData());
	}

	function errorFun(data){
   	    orderLookup.hideLoadingOverlay();
	}

	orderLookup.init();
	//const ordersDataTableObj = $("#lookup-order-wrapper .data-table-component").dataTable();
	function renderActionWrap(data, type, row, meta) {
	    let newRender;
	    let statusTarget = actionList["actions"];
	    newRender = render(
	      actionCellDropdownTemplate, {
	        list: renderActionCellList(statusTarget,data,row),
	        index: meta.row
	      }
	    );
	    return newRender;
    };

    function renderActionHeaderWrap() {
  	    let statusTarget = actionList['all'];
	    let newRender;
	    let data = "";
	    let row = "";
	    newRender = render(
	      actionHeaderDropdownTemplate, {
	        list: renderActionCellList(statusTarget,data,row)
	      }
	    );
	    return newRender;
    };

    function renderActionCellList(list,data,row) {
	    let renderedList;
	    renderedList = _(list).map((item)=>{
	      return render(
	        actionCellDropdownItemTemplate, {
	          icon: item.icon,
	          title: item.title,
	          cls: item.cls,
	          disabled:checkDisableForGivenAction(data,row,item.title)
	        }
	      )
   		});
	    return renderedList.join('');
    };

	function checkDisableForGivenAction(data,row,actionName) {
	 	if(isRowLevelActionCheck(data)){
	    	return callBusinessLogicToDisableAction(data,row,actionName);
	    }else{
	      	let isTrue = false;
	    	_(selectedRows).map((item)=>{
	      		if(callBusinessLogicToDisableAction(item.data.ordStatus,item.data,actionName)){
	    			if (!isTrue){
	    				isTrue = true;
	    			}
	    		}
	        });
	    	return isTrue;
		}
	};

	function isRowLevelActionCheck(data) {
		return isPresent(data);
	}

	function callBusinessLogicToDisableAction(data,row,actionName) {
		if (orderPortletEditPerm && isPresent(data)) {
			if(actionName == "Cancel"){
				if(row.partner.parId == disableCancel || !(data === "Error" || data === "Held" || data === "Backordered")) {
					return true;
				}else{
					return false;
				}
			}
			else if(actionName == "Release"){
				if (data === "Held" || data === "Hold Pending") {
					return false
				}else{
					return true;
				}
			}
			else if(actionName == "Edit"){
				if(isRowLevelActionCheck(row) && disableEditingOfOrders(data, row)){
					return true;
				}else{
					return false;
				}
			}
		}
	}

	function disableEditingOfOrders(data, row){
		let shouldDisableEdit = false;
		_.each(disableEdit, function(domain){
			if((domain.cdmValue===row.partner.parId) || (domain.cdmValue===row.ordOrderType) || (domain.cdmValue===row.ordShippingMethod)){
				shouldDisableEdit = true;
			}
		});
		if(!shouldDisableEdit){
			if(!(data === "Error" || data === "Held" || data === "Backordered")){
				shouldDisableEdit = true;
			}
		}
		return shouldDisableEdit;
	}
	// Cancel order button click at row level.
	$('body').on('click', '.cancel-order', function(e) {
		e.preventDefault();
		if(shallAllowClick(this))
		{
			// Since the menu ends up in the body when this lookup is happening, have to carry the index of the parent dropdown
			let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
			// Get the row based on the parent...
			let parent = $(".dropdown-parent-" + pIndex).parents('tr');
			// Get the row data
			let row = $(".data-table-component").dataTable().api().row(parent);
			submitModalFlow.showLoadingModal();
			$.ajax({
			  url: getCancelReasonUrl,
			  type: 'POST',
			  dataType: 'JSON',
			  data: {
			    orderId: row.data().ordOrderId,
			  },
			  success: function(data){
			  	submitModalFlow.hideAllModals();
			    if(data.response == "success") {
			      $('#modalCancelOrder').attr('disabled',true);
			      $('#orderCancelReason').val('0');
			      $("#cancelModal").appendTo("body").data('row', row).modal("show");
			      emptyCurrentResonList("orderCancelReason");
			      fillReasonList(data.reasonList,"orderCancelReason");
			    }
			  },
			  error:function(data){
			    submitModalFlow.hideAllModals();
			  }
			});

		}
	});
	// Release order button click at row level
	$('body').on('click', '.release-order', function(e) {
		e.preventDefault();
		// Since the menu ends up in the body when this lookup is happening, have to carry the index of the parent dropdown
		let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
		// Get the row based on the parent...
		let parent = $(".dropdown-parent-" + pIndex).parents('tr');
		// Get the row data
		let row = $(".data-table-component").dataTable().api().row(parent);

		if(shallAllowClick(this))
		{
			$("#releaseModal").appendTo("body").data('row', row).modal("show");
		}
	});
	// Release orders button click - Header level.
	$('body').on('click', '.bulk-release-order', function(e) {
		e.preventDefault();
		if(shallAllowClick(this)){
			$("#bulkReleaseModal").modal("show");
		}
	});

    function shallAllowClick(currentObj){
   		return 	!($(currentObj).hasClass("disabled"));
    }


	// Cancel orders button click at Header level - This functionality is needs to be taken out for time being but will use below code in future release - this is not being called from anywhere as of now.
	$('body').on('click', '.bulk-cancel-order', function(e) {
		e.preventDefault();
		if(shallAllowClick(this)){
			// Since the menu ends up in the body when this lookup is happening, have to carry the index of the parent dropdown
			let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
			// Get the row based on the parent...
			let parent = $(".dropdown-parent-" + pIndex).parents('tr');
			// Get the row data
			let row = $(".data-table-component").dataTable().api().row(parent);
			$.ajax({
			  url: getCancelReasonUrl,
			  type: 'POST',
			  dataType: 'JSON',
			  data: {
			    //orderId: row.data().ordOrderId,
			},
			success: function(data){
			  	submitModalFlow.hideAllModals();
			    if(data.response == "success") {
			      $('#modalBulkCancelOrder').attr('disabled',true);
			      $("#orderBulkCancelReason").val('0');
			      $("#bulkCancelModal").appendTo("body").data('row', row).modal("show");
			      emptyCurrentResonList("orderBulkCancelReason");
			      fillReasonList(data.reasonList,"orderBulkCancelReason")
			    }
			  },
			  error:function(data){
			    submitModalFlow.hideAllModals();
			  }
			});
		}
	});


	var emptyCurrentResonList = function(element){
		var options = $("#"+element).find("option");
		$.each(options, function(key, item) {
		  if(key != 0){
		    item.remove();
		  }
		});
	}

	var fillReasonList = function(data,element){
		$.each(data, function(key, item) {
		 var option = $('<option /\>');
		 option.attr('value', key).text(item);
		 $("#"+element).append(option);
		});
	}

	$(".orderCancelReason" ).change(function() {
	  $('#modalCancelOrder').attr('disabled',false);
	  $('#modalBulkCancelOrder').attr('disabled',false);
	});


	$('#modalCancelOrder').click(function(){
	    var row = $('#cancelModal').data('row');
	    var reason = $('.orderCancelReason :selected').text();
	    var value = $('.orderCancelReason :selected').val();
	    submitModalFlow.showLoadingModal();
	    cancelOrder(row,reason,value);
	});


	$('#modalBulkCancelOrder').click(function(){
	    var reason = $('.orderCancelReason :selected').text();
	    var value = $('.orderCancelReason :selected').val();
	    submitModalFlow.showLoadingModal();
	    bulkCancelOrder(reason,value);
	});

    function bulkCancelOrder(reason,value){
	    $.ajax({
	      url: cancelOrderUrl,
	      type: 'POST',
	      dataType: 'JSON',
	      data: {
	        reason :  reason,
	        value :  value
	      },
	      success: function(data){
			if(data.response == "success") {
			  submitModalFlow.showSuccessModal();
			 _(selectedRows).map((item)=>{
				      let currentRow =  $(".data-table-component").dataTable().api().row(item.rowIndex)
				      var d = currentRow.data();
			      d.ordStatus=$.trim(data.ordStatusCd);
			      currentRow.data(d).draw();
			 });
			 orderLookup.uncheckAllSelected();
			  setTimeout(function() {
			     location.reload();
			  }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
			}

	      },
		  error:function(data){
		     submitModalFlow.hideAllModals();
		  }
    	});
    }

    function cancelOrder(row,reason,value){
		$.ajax({
		  url: cancelOrderUrl,
		  type: 'POST',
		  dataType: 'JSON',
		  data: {
		    orderId: row.data().ordOrderId,
		    reason :  reason,
		    value :  value
		  },
		  success: function(data){
		    if(data.response == "success") {
		      var d = row.data();
		      d.ordStatus=$.trim(data.ordStatusCd);
		      row.data(d).draw();
		      submitModalFlow.showSuccessModal();
			  setTimeout(function() {
			  submitModalFlow.hideAllModals();
		      },  SUCCESS_MODAL_TIMEOUT);

		    }

		  },
		  error:function(data){
		     submitModalFlow.hideAllModals();
		  }
		});
	}

   $('#bulkReleaseModalSubmitBtn').click(function(){
     submitModalFlow.showLoadingModal();
     bulkRelease();
   });


	function bulkRelease(){
	    $.ajax({
	      url: bulkReleaseOrderUrl,
	      type: 'POST',
	      dataType: 'JSON',
	      data: {
	        orderId: getAllSelectedOrderIds()
	      },
	      success: function(data){
	      if(data.response == "success") {
	         _(selectedRows).map((item)=>{
	      	      let currentRow =  $(".data-table-component").dataTable().api().row(item.rowIndex)
	     	      var d = currentRow.data();
		          d.ordStatus=$.trim(data.ordStatusCd);
		          currentRow.data(d).draw();
	    	 });
	    	 orderLookup.uncheckAllSelected();
			  setTimeout(function() {
			    submitModalFlow.hideAllModals();
			  },  SUCCESS_MODAL_TIMEOUT);

	        }
	      },
		  error:function(data){
			  submitModalFlow.hideAllModals();
		  }
	    });
	 };

	function getAllSelectedOrderIds(){
		var OrderIds = new Array();
		_(selectedRows).map((item)=>{
			OrderIds.push(item.data.ordOrderId);
		 });
		return JSON.stringify(OrderIds);
	}


    $('#releaseModalSubmitBtn').click(function(){
      var row = $('#releaseModal').data('row');
      submitModalFlow.showLoadingModal();
      release(row);
    });

	function release(row){
	    $.ajax({
	      url: releaseOrderUrl,
	      type: 'POST',
	      dataType: 'JSON',
	      data: {
	        orderId: row.data().ordOrderId,
	      },
	      success: function(data){
	        if(data.response == "success") {
	          var d = row.data();
	          d.ordStatus=$.trim(data.ordStatusCd);
	          row.data(d).draw();
	          submitModalFlow.showSuccessModal();
			  setTimeout(function() {
				  submitModalFlow.hideAllModals();
		      },  SUCCESS_MODAL_TIMEOUT);
	        }
	      },
		  error:function(data){
			  submitModalFlow.hideAllModals();
		  }
	    });
	};

 //    $("#exportData").click(function() {
	// 	var totRowCount = $('#totalRows').val();
	// 	$('#modalExportData').attr('disabled', true);
	// 	$('#dataFileType').val('0');
	// 	$('#row-count').html(" " + totRowCount + " ");
	// 	$("#exportModal").appendTo("body").modal("show");
	// });


	// $('#modalExportData').click(function() {
	// 	var fileType = $('#dataFileType :selected').val();
	// 	exportToFile(fileType);
	// 	$("#exportModal").modal("hide");
	// });


	// $('#dataFileType').change(function() {
	// 	$('#modalExportData').attr('disabled', false);
	// });

	// var exportToFile = function(fileType) {
	// 	let currentData = orderLookup.generateData();
	// 	var startDate = readSpecificKeyFromSearchCriteria(currentData["searchCriteria"],'startDate');
	// 	var endDate = readSpecificKeyFromSearchCriteria(currentData["searchCriteria"],'endDate');
	// 	var fixedRangeDate = readSpecificKeyFromSearchCriteria(currentData["searchCriteria"],'fixedRange');
	// 	var revisedSearchCriteria =  alterSearchCriteriForController(currentData["searchCriteria"])
	// 	var orderBy =  currentData["orderBy"] == 'ordStatus' ? "ordStatusCode" : currentData["orderBy"]
	// 	var searchCriteria =   _.toArray(revisedSearchCriteria).length > 0 ? JSON.stringify(_.toArray(revisedSearchCriteria)) : _.toArray(revisedSearchCriteria);
	// 	var url = generateExportUrl+"&endDate="+endDate+"&startDate="+startDate+"&fixedRange="+fixedRangeDate+"&page=0"+"&size=1000"+"&orderBy="+orderBy+"&orderByType="+currentData["sortType"]+"&searchCriteria="+searchCriteria+"&fileType="+fileType;
	// 	window.open(url);
	// };

	// Export component integration.
	function initExport() {
		let exportObj  =  {
		  title : $(targetSelector).data("export-popup-title"),
		  exportAttemptTextPart1Lang: $(targetSelector).data("export-attempt-text-part1"),
		  exportAttemptTextPart2Lang: $(targetSelector).data("export-attempt-text-part2"),
		  exportMaxLimitLang: $(targetSelector).data("export-max-row-limit")
		};
		exportModal.init(exportObj);
		exportModal.bindExportEvent();
	}

	function setExportData(currentData) {
		exportModal.buildExportBasicURL(generateExportUrl,currentData);
		exportModal.setExportCount(currentData.totalElements);
	}
  	initExport();
	setExportData(orderLookup.generateData());
	  // Allow custom dropdowns to work (based on class 'overflow-dropdown'), check the template for more information;
  	handleCustomDropdownEvents();

		$("th.dtc-action-column").html(renderActionHeaderWrap());
		
		let editErrorModal = $(render(
			modalHtml, {
				title: "Edit Order",
				leftAlignTitle: true,
				body: renderErrorModalPill(),
				topCloseBtn: true,
				autoHideTop: true,
				footerBtns: '<a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a><a href="#" class="base-btn purple-btn edit-order-modal"> Edit Order </a>'
			}
		));
	
		let editBackOrderedModal = $(render(
			modalHtml, {
				title: "Edit Order",
				leftAlignTitle: true,
				body: renderBackOrderedModal(),
				topCloseBtn: true,
				autoHideTop: true,
				footerBtns: '<a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a><a href="#" class="base-btn purple-btn edit-order-modal"> Edit Order </a>'
			}
		));
	
		let editManualHoldModal = $(render(
			modalHtml, {
				title: "Edit Order",
				leftAlignTitle: true,
				body: renderOrderHeldModal(),
				topCloseBtn: true,
				autoHideTop: true,
				footerBtns: '<a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a><a href="#" class="base-btn purple-btn edit-order-modal"> Edit Order </a>'
			}
		));
	
		let editCustomHeldModal = $(render(
			modalHtml, {
				title: "Edit Order",
				leftAlignTitle: true,
				body: renderCustomHeldModal(),
				topCloseBtn: true,
				autoHideTop: true,
				footerBtns: '<a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a><a href="#" class="base-btn purple-btn edit-order-modal"> Edit Order </a>'
			}
		));
	
		let editChannelHeldModal = $(render(
			modalHtml, {
				title: "Edit Order",
				leftAlignTitle: true,
				body: renderChannelHeldModal(),
				topCloseBtn: true,
				autoHideTop: true,
				footerBtns: '<a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a><a href="#" class="base-btn purple-btn edit-order-modal"> Edit Order </a>'
			}
		));
		
		let editPortalHeldModal = $(render(
			modalHtml, {
				title: "Edit Order",
				leftAlignTitle: true,
				body: renderPortalHeldModal(),
				topCloseBtn: true,
				autoHideTop: true,
				footerBtns: '<a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a><a href="#" class="base-btn purple-btn edit-order-modal"> Edit Order </a>'
			}
		));
	
		function renderPortalHeldModal(){
				return render(editPortalHeldOrderModal, {
					statusPill: renderPillForModal("Held")
				});
		}
	
		function renderChannelHeldModal(){
			return render(editChannelHeldOrderModal, {
				statusPill: renderPillForModal("Held")
			});
		}
	
		function renderCustomHeldModal(){
			return render(editCustomHeldOrderModal, {
				statusPill: renderPillForModal("Held")
			});
		}
	
		function renderOrderHeldModal() {
			return render(editHeldOrderModal, {
				statusPill: renderPillForModal("Held")
			});
		}
	
		function renderBackOrderedModal(){
			return render(editBackOrderedOrderModal, {
				statusPill: renderPillForModal("Backordered")
			});
		}
	
		function renderErrorModalPill(){
			return render(editErrorOrderModal, {
				statusPill: renderPillForModal("Error")
			});
		}
	
		$('body').append(editErrorModal, editBackOrderedModal, editCustomHeldModal, editPortalHeldModal, editChannelHeldModal, editManualHoldModal);

		function renderPillForModal(status){
			let newRender;
			let statusPillClass = pillStatusClasses[status] || pillStatusClasses.default;
			let statusText = "Order " + status;
			return newRender = render(
				statusPillBodyHtml, {
					statusText,
					statusPillClass
				}
			);
		}

	let timeinterval;
	function populateGraceperiod(orderCreatedDate, gracePeriod) {
		let dateToUseForScheduledReleaseCalculation = orderCreatedDate;
		let scheduledReleaseDate = moment(dateToUseForScheduledReleaseCalculation, datTimeFormat).add(gracePeriod, 'm');
		let t = scheduledReleaseDate - new Date();
		if (t > 0) {
			if(timeinterval){
				clearInterval(timeinterval);
			}
			timeinterval = setInterval(function () {
				let timeObj = getTimeRemaining(scheduledReleaseDate);
				if (timeObj.total > 0) {
					let countDownTime = "";
					if (timeObj.days > 0) {
						countDownTime = `${_.escape(formatTime(timeObj.days))} Days ${_.escape(formatTime(timeObj.hours))} : ${_.escape(formatTime(timeObj.minutes))} : ${_.escape(formatTime(timeObj.seconds))}`;
					} else {
						countDownTime = `${_.escape(formatTime(timeObj.hours))} : ${_.escape(formatTime(timeObj.minutes))} : ${_.escape(formatTime(timeObj.seconds))}`;
					}
					$(".countdown-time-modal").html(countDownTime);
				} else {
					clearInterval(timeinterval);
				}
			}, 1000);
		} 
	}

	function getTimeRemaining(scheduledReleaseDate) {
    let today = getESTDate(new Date());
    let t = scheduledReleaseDate - today;
    let seconds = Math.floor( (t/1000) % 60 );
    let minutes = Math.floor( (t/1000/60) % 60 );
    let hours = Math.floor( (t/(1000*60*60)) % 24 );
    let days = Math.floor( t/(1000*60*60*24) );
    return {
      'total': t,
      'days': days,
      'hours': hours,
      'minutes': minutes,
      'seconds': seconds
    };
  }

  function formatTime(i) {
    if (i < 10) {
      i = "0" + i;
    }
    return i;
  }

	let orderIdForEdit;

	$('body').on('click', '.edit-order-modal', function(e) {
		e.preventDefault();
		if(shallAllowClick(this))
		{
			location.href = `${editOrderUrl}&${portletNamespace}orderIdForEdit=${orderIdForEdit}`;
		}
	});

	$('body').on('click', '.edit-order', function(e) {
		e.preventDefault();
		// Since the menu ends up in the body when this lookup is happening, have to carry the index of the parent dropdown
		let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
		// Get the row based on the parent...
		let parent = $(".dropdown-parent-" + pIndex).parents('tr');
		// Get the row data
		let row = $(".data-table-component").dataTable().api().row(parent);
		orderIdForEdit=row.data().ordOrderId;
		if(row.data().ordStatus == "Error"){
      showEditOrderModalError();
    }
    if(row.data().ordStatus == "Backordered"){
      showEditOrderModalBackordered();
    }
    if(row.data().ordStatus == "Held"){
			populateGraceperiod(row.data().ordCreatedDate, row.data().ordGracePeriod);
			if(row.data().ordChannelType != "Manual" && row.data().ordChannelType != "Manual (Bulk)" && row.data().ordChannelType != "API" && row.data().ordChannelType != "BigCommerce"){
        showEditChannelHeldModal();
      }else{
				if(row.data().ordReleaseType == "Hold Indefinitely"){
					showEditOrderManualHeldModal();
				}
				else if(row.data().ordReleaseType == "Scheduled Release"){
					showEditCustomHeldModal();
				}
				else if(row.data().ordReleaseType == "Internal Order Grace Period" || row.data().ordReleaseType == "Channel Order Grace Period"){
					showEditPortalHeldModal();
				}
			}
    }
	});

	function showEditOrderModalError(){
    editErrorModal.modal('show');
  }

  function showEditOrderModalBackordered(){
    editBackOrderedModal.modal('show');
  }

  function showEditOrderManualHeldModal(){
    editManualHoldModal.modal('show');
  }

  function showEditCustomHeldModal(){
    editCustomHeldModal.modal('show');
  }

  function showEditChannelHeldModal(){
    editChannelHeldModal.modal('show');
  }
  
  function showEditPortalHeldModal(){
    editPortalHeldModal.modal('show');
	}
	
});



// WEBPACK FOOTER //
// ./src/pages/order/lookup.js